import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useQuery } from "@apollo/client";
import { GET_DATA_INTEGRATION_BY_ID, GET_TENANT_BY_ID } from "../../graphql/TenantQueries";




function DataIntModal({ setOpenDataIntModal, setOpenActionModal, fieldData }: any) {

    const { loading, error, data } = useQuery(GET_DATA_INTEGRATION_BY_ID, { variables: { id: fieldData } })
    const { loading: tenantLoading, error: tenantError, data: tenantData } = useQuery(GET_TENANT_BY_ID, { variables: { id: fieldData } })
    if (loading || tenantLoading) return <h3>Loading...</h3>
    return (
        <>
            <div className={styles["formModalContainer"]}>
                <div className={styles["title"]}>
                    <h1>Tenant Data Integration</h1>
                    <h4 style={{ display: 'flex' }}>Tenant</h4>
                    <div style={{ display: 'grid' }}>
                        <div>
                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tenant Name:</label>
                            <p style={{ float: 'left' }}>{tenantData?.getTenantById?.name ? tenantData.getTenantById.name : ""}</p>
                        </div>
                        <div>
                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tenant Display Name:</label>
                            <p style={{ float: 'left' }}>{tenantData?.getTenantById?.displayName ? tenantData.getTenantById.displayName : ""}</p>
                        </div>
                        <div>
                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tenant ID:</label>
                            <p style={{ float: 'left' }}>{tenantData?.getTenantById?.id ? tenantData.getTenantById.id : ""}</p>
                        </div>
                        <hr/>
                    </div>

                    {data?.getDataIntegrationByTenantId.length === 0 && <h3>No Data Integration for this Tenant</h3>}

                    {data?.getDataIntegrationByTenantId && data?.getDataIntegrationByTenantId?.map((el: any) =>
                        <>
                            <h4 style={{ display: 'flex' }}>Data Integration</h4>
                            <div style={{ display: 'grid' }}>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Application ID:</label>
                                    <p style={{ float: 'left' }}>{el.esri.appId}</p>
                                </div>
                                <div>
                                    <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Application Secret:</label>
                                    <p style={{ float: 'left' }}>{el.esri.appSecret}</p>
                                </div>

                                {el.esri.layers && el.esri.layers?.map((el: any) =>
                                    <>
                                        <div>
                                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Layer Name: </label>
                                            <p style={{ float: 'left' }}>{el.layerName}</p>
                                        </div>
                                        <div>
                                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Display Name: </label>
                                            <p style={{ float: 'left' }}>{el.displayName}</p>
                                        </div>
                                        <div>
                                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Layer Number: </label>
                                            <p style={{ float: 'left' }}>{el.layerNumber}</p>
                                        </div>
                                        <div>
                                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Layer Field Mapping: </label>
                                            <p style={{ float: 'left' }}>{el.layerFieldMapping}</p>
                                        </div>
                                        <div>
                                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Tags: </label>
                                            <p style={{ float: 'left' }}>{el.tags}</p>
                                        </div>
                                        <div>
                                            <label style={{ float: 'left', paddingRight: '8px', paddingLeft: '10px' }}>Group Number: </label>
                                            <p style={{ float: 'left' }}>{el.group}</p>
                                        </div>
                                    </>
                                )
                                }

                            </div>
                            <hr />
                        </>
                    )
                    }


                    <div style={{ paddingTop: '30px' }}>
                        <button
                            onClick={() => {
                                setOpenDataIntModal(false);
                            }}
                            className={styles["button"]}
                            style={{ display: 'block', }}
                        >
                            Cancel
                        </button>
                    </div>

                </div>
            </div>
        </>

    )
}

export default DataIntModal;